import { ArrowLeftIcon } from '@heroicons/react/solid';
import { Heading, Link, Mesh } from '..';

interface VacancyHeaderProps {
  title?: string;
  short?: string;
  keywords?: any[];
}

export const VacancyHeader = ({
  title,
  short,
  keywords,
}: VacancyHeaderProps) => {
  return (
    <div className="relative bg-yellow-50">
      <div className="lg:max-w-6xl text-lg mx-auto md:pb-6 pt-24 relative z-20">
        <div className="px-14">
          <div className="text-center">
            <Link
              href="/careers"
              className="mb-14 md:mb-24 mx-auto inline-flex items-center text-md font-medium text-gray-900 hover:text-gray-700"
            >
              <ArrowLeftIcon
                className="w-4 h-4 mr-2 -mt-0.5"
                aria-hidden="true"
              />
              Back to job openings
            </Link>
          </div>

          {!!title && (
            <Heading as="h1" variant="h2" className="text-center md:text-left">
              {title}
            </Heading>
          )}

          {short && (
            <p className="mt-4 text-base text-grey-700 sm:text-lg text-center md:text-left">
              {short}
            </p>
          )}

          {keywords && (
            <div className="flex w-full items-center justify-center mt-10 md:hidden">
              {keywords?.map((keyword, i) => (
                <p className="font-bold text-grey-700">
                  {i === 0 ? (
                    keyword?.text
                  ) : (
                    <div className="flex">
                      <div className="font-bold text-grey-700 ml-2">•</div>
                      <div className="ml-2 font-bold text-grey-700">
                        {keyword?.text}
                      </div>
                    </div>
                  )}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="relative h-20 md:h-40 flex flex-col overflow-hidden">
        <div className="h-full bottom-0 bg-gradient-to-b from-yellow-50 relative z-10" />
        <Mesh className="absolute bottom-0 w-[1140px] min-w-full left-1/2 transform -translate-x-1/2 xl:w-full z-0 opacity-70" />
      </div>
    </div>
  );
};
